// src/services/unidadesService.js

import api from "./api";
const unidadesService = {
  verificar: (p={}) => {
    const qs = new URLSearchParams(Object.entries(p).filter(([,v])=>v!==undefined&&v!==""));
    return api("GET", `/unidades/verificar?${qs}`);
  },
  listar:      (p={}) => { const qs=new URLSearchParams(Object.entries(p).filter(([,v])=>v!==""&&v!==undefined)); return api("GET",`/unidades?${qs}`); },
  stats:       (idCondominio) => api("GET",`/unidades/stats?idCondominio=${idCondominio}`),
  buscarPorId: (id)   => api("GET",  `/unidades/${id}`),
  listarContatos: (id) => api("GET", `/unidades/${id}/contatos`),
  listarBlocos:(idCondominio) => api("GET",`/unidades/blocos?idCondominio=${idCondominio}`),
  criar:       (data) => api("POST", "/unidades", data),
  criarBulk:   (idCondominio, unidades) => api("POST", "/unidades/bulk", { idCondominio, unidades }),
  atualizar:   (id,data) => api("PUT",`/unidades/${id}`, data),
  deletar:     (id)   => api("DELETE",`/unidades/${id}`),
  previewLote: (data) => api("POST", "/unidades/lote", {...data, preview:true}),
  gerarLote:   (data) => api("POST", "/unidades/lote", {...data, preview:false}),
  listarVeiculos:   (idUnidade) => api("GET",   `/unidades/veiculos/list?idUnidade=${idUnidade}`),
  criarVeiculo:     (data)      => api("POST",   "/unidades/veiculos", data),
  atualizarVeiculo: (id,data)   => api("PUT",   `/unidades/veiculos/${id}`, data),
  deletarVeiculo:   (id)        => api("DELETE", `/unidades/veiculos/${id}`),
  listarPets:   (idUnidade) => api("GET",   `/unidades/pets/list?idUnidade=${idUnidade}`),
  criarPet:     (data)      => api("POST",   "/unidades/pets", data),
  atualizarPet: (id,data)   => api("PUT",   `/unidades/pets/${id}`, data),
  deletarPet:      (id)     => api("DELETE", `/unidades/pets/${id}`),
  listarCondominos:(id)     => api("GET",    `/unidades/${id}/condominos`),
};

export default unidadesService;
